import {I_ROLE,I_POLE,I_ORGANISATION,I_SITE,I_FUNCTION,I_REFERENTIAL} from '../services/api/interfaces/I_HELLO';
import {I_OPTION} from '../tsx/components';

/**
 *
 * @param param0
 * @returns
 */
export const getActivityTypeLabel = ({id,allActivityTypes}:{id:number,allActivityTypes?:I_OPTION[]}):string => {
  if (!id) {
    return '';
  }
  let label = id + '';
  if (id && allActivityTypes) {
    const matching = allActivityTypes.filter(r => r.value === id+'');
    if (matching && matching.length > 0) {
      label = matching[0].name;
    }
  }
  return label;
};

/**
 *
 * @param param0
 * @returns
 */
export const getBillingCustomerLabel = ({id,allBillingCustomers}:{id:number,allBillingCustomers?:I_OPTION[]}):string => {
  if (!id) {
    return '';
  }
  let label = id + '';
  if (id && allBillingCustomers) {
    const matching = allBillingCustomers.filter(r => r.value === id+'');
    if (matching && matching.length > 0) {
      label = matching[0].name;
    }
  }
  return label;
};

/**
 * NB : pour le moment la valeur "roles" ne contient qu'un seul role
 * @param param0
 * @returns
 */
export const getRoleLabel = ({role,allRoles}:{role?:string,allRoles?:I_ROLE[]}):string => {
  if (!role) {
    return '';
  }
  let userFormattedRole = role;
  if (role && allRoles) {
    const matchingRole = allRoles.filter(r => r.key === role);
    if (matchingRole && matchingRole.length > 0) {
      userFormattedRole = matchingRole[0].name;
    }
    else if(role === 'sa') {
      userFormattedRole = 'Super Admin';
    }
  }
  return userFormattedRole;
};

/**
 * Renvoie le libellé d'une fonction
 * @param param0
 * @returns
 */
export const getFunctionLabel = ({func,allFunctions}:{func?:string,allFunctions?:I_FUNCTION[]}):string => {
  if (!func) {
    return '';
  }
  let userFormattedFunction = func;
  if (func && allFunctions) {
    const matchingFunction = allFunctions.filter(r => r.key === func);
    if (matchingFunction && matchingFunction.length > 0) {
      userFormattedFunction = matchingFunction[0].label;
    }
  }
  return userFormattedFunction;
};

/**
 * Renvoie le libellé d'un site de rattachement
 * @param param0
 * @returns
 */
export const getSiteLabel = ({site,allSites}:{site?:string,allSites?:I_SITE[]}):string => {
  if (!site) {
    return '';
  }
  let userFormattedSite = site;
  if (site && allSites) {
    const matchingSite = allSites.filter(r => r.key === site);
    if (matchingSite && matchingSite.length > 0) {
      userFormattedSite = matchingSite[0].label;
    }
  }
  return userFormattedSite;
};

/**
 * Renvoie le libellé d'une direction
 * @param param0
 * @returns
 */
export const getDirectionLabel = ({direction,allDirections}:{direction?:string,allDirections?:I_ORGANISATION[]}):string => {
  if (!direction) {
    return '';
  }
  if (!allDirections || allDirections.length === 0) {
    return direction;
  }
  // niveau 1 - direction
  const matchingItem = allDirections.filter(r => r.key === direction);
  if (matchingItem && matchingItem.length > 0) {
    return matchingItem[0].label;
  }
  // niveau 2 - hub
  let foundLabel = undefined;
  allDirections.forEach(r => {
    const poles = r.poles;
    if (poles) {
      const matchingPole = poles.filter(p => p.key === direction);
      if (matchingPole && matchingPole.length > 0) {
        foundLabel = matchingPole[0].label;
      }
    }
  });
  return foundLabel || direction;
};

/**
 * Concatene tous les poles de toutes les directions en un seul array
 * @param param0
 * @returns
 */
export const getAllDirectionPole = ({allDirections,filtersDirections}:{allDirections?:I_ORGANISATION[],filtersDirections?:string[]}):I_POLE[] => {
  if (!allDirections) {
    return [];
  }
  let allPoles:I_POLE[] = [];
  allDirections.forEach(d => {
    // si cette direction n'est pas dans les filtres, skip
    if (filtersDirections && filtersDirections.indexOf(d.key) === -1) {
      return;
    }
    allPoles = allPoles.concat(d.poles);
  });
  return allPoles;
};


/**
 * Renvoie le libellé d'un agrément
 * @param param0
 * @returns
 */
export const getReferentialLabel = ({referential,allReferentials}:{referential?:string,allReferentials?:I_REFERENTIAL[]}):string => {
  if (!referential) {
    return '';
  }
  let userFormatted = referential;
  if (referential && allReferentials) {
    const matching = allReferentials.filter(r => r.key === referential);
    if (matching && matching.length > 0) {
      userFormatted = matching[0].label;
    }
  }
  return userFormatted;
};
